module.exports = __webpack_public_path__ + "static/lrw-temp-simplified-logo-vector-bw-4371c4b4a99a32a32d7eea2d2bd572b2.png";